import React from 'react'
import { UserTwoStepsCell } from './UserTwoStepsCell'
import { UserActionsCell } from './UserActionsCell'
import Moment from 'moment'
import { ColumnDef } from '@tanstack/react-table'
import { Admin } from '../../core/_models'

const backOfficeColumns = (
  refetch: () => void = () => {}
): ColumnDef<Admin>[] => [
  {
    header: 'Registrazione',
    accessorKey: 'createdAt',
    id: 'created_at',
    cell: ({ getValue }) =>
      Moment(getValue() as string).format('DD-MM-YYYY HH:mm')
  },
  {
    header: 'Username',
    accessorKey: 'username'
  },
  {
    header: 'Nome',
    accessorKey: 'firstName'
  },
  {
    header: 'Cognome',
    accessorKey: 'lastName'
  },
  {
    header: 'Email',
    accessorKey: 'email'
  },
  {
    header: 'Stato',
    accessorKey: 'status',
    cell: ({ getValue }) => (
      <UserTwoStepsCell two_steps={getValue() as boolean} />
    )
  },
  {
    header: 'Azioni',
    id: 'actions',
    cell: ({ row }) => (
      <UserActionsCell
        admin={row.original}
        onChangeUserStatus={refetch}
        onDelete={refetch}
      />
    )
  }
]

export { backOfficeColumns }
